var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleQuotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 38,
    viewBox: "0 0 48 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5836 19.418C43.9104 19.418 47.5 23.1904 47.5 28.7798C47.5 33.8096 43.3743 38 37.7862 38C31.6655 38 27.1429 32.9702 27.1429 25.2873C27.1429 7.82454 39.6489 0.839455 47.5 0V7.68291C42.1766 8.66055 36.1916 14.1084 35.9236 20.1193C36.1916 19.9811 37.2536 19.418 38.5836 19.418ZM11.4441 19.418C16.7641 19.418 20.3571 23.1904 20.3571 28.7798C20.3571 33.8096 16.2314 38 10.6434 38C4.52268 38 0 32.9702 0 25.2873C0 7.82454 12.5061 0.839455 20.3571 0V7.68291C15.0337 8.66055 9.04875 14.1084 8.78071 20.1193C9.04875 19.9811 10.1107 19.418 11.4441 19.418Z",
    fill: "#FEC10D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleQuotes);
export default __webpack_public_path__ + "static/media/double-quotes.bd47d33a6b6ea9954192375b988a43af.svg";
export { ForwardRef as ReactComponent };